
import { Component, Prop, Vue } from "vue-property-decorator";
import { DateHelper } from "../../core/helpers/dateHelper";
import store from "../../core/store";

@Component
export default class PostCard extends Vue {
  @Prop({ required: true }) private post!: any;
  @Prop({ required: true }) private index!: number;
  private images: any[] = [];

  async mounted() {
    this.setDefaultImages();
    console.log("POST: ", this.post);
  }

  private setDefaultImages() {
    const context = require.context(
      "@/images/blogs",
      false,
      /\.(png|jpe?g|webp|gif)$/
    );
    this.images = context.keys().map(context);
  }

  getImage(name: string, index: number) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return this.images[index % this.images.length];
  }

  getDateFormatted(date: string) {
    const d: any = DateHelper.toDate(date, DateHelper.systemFormat);

    const sdate = DateHelper.toServerFormat(d);
    return DateHelper.beautifyDate(sdate, false, true, true, false);
  }

  formatHours(date: string) {
    const d: any = DateHelper.toDate(date, DateHelper.systemFormat);
    const hours = d.getHours();
    const minutes = d.getMinutes();
    if (hours === 0 && minutes === 0) {
      return "";
    }
    return DateHelper.extractTime(date);
  }

  getPlainDetail(html: string): string {
    if(html == null){
      return "";
    }
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }
}
